import { useCallback } from "react";
import { useBeforeSetting } from "@/store/beforeSetting";
import { sys } from "@/Core/utils/system";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import useDialogManager from "@/utils/useDialogManager";
import { shouldOpenCustomerServiceInIframe } from "./customerServiceUrlHandling";

/**
 * WhatsApp客服Hook
 * 提供WhatsApp客服相关功能
 */
const useWhatsApp = () => {
  const { data } = useBeforeSetting();
  const { whatsapp } = data || {};
  const { t } = useTranslationPlus("CustomerService");
  const { openDialogIFrame } = useDialogManager();
  /**
   * 获取WhatsApp客服链接
   * @returns WhatsApp客服链接
   */
  const getCustomerServiceUrl = useCallback(() => {
    return whatsapp;
  }, [whatsapp]);

  const openCustomerService = useCallback(
    (url: string | null | undefined = whatsapp) => {
      const customerServiceUrl = url?.trim();
      if (!customerServiceUrl) {
        return false;
      }

      if (shouldOpenCustomerServiceInIframe(customerServiceUrl)) {
        openDialogIFrame({
          title: t("whatsapp_customer"),
          url: customerServiceUrl,
          type: "customer-service",
        });
      } else {
        sys.openUrl(customerServiceUrl);
      }

      return true;
    },
    [openDialogIFrame, t, whatsapp]
  );

  return {
    getCustomerServiceUrl,
    openCustomerService,
  };
};

export default useWhatsApp;
